import React from 'react';
import { getBackgroundImg } from '@nutastic/nutastic-react-app';
import classnames from 'classnames';

// eslint-disable-next-line react/prop-types
const CategoryBox = ({ className, image, onClick, title, subtitle }) => {
    const componentClass = 'categoryBox';
    const classes = classnames(componentClass, {
        [className]: !!className
    });

    const onBoxClick = () => {
        onClick && onClick();
    };

    return <div className={classes} onClick={onBoxClick}>
        <div className={`${componentClass}__image`} style={getBackgroundImg(image)} />
        { title && <div className={`${componentClass}__title`}>
            { subtitle && <small>{ subtitle }</small> }
            <span>{ title }</span>
        </div> }
    </div>;
};

export default CategoryBox;
